import {React, useState, useEffect} from 'react'
import { Routes, Route, Navigate , Link } from 'react-router-dom'
import { getProductsByTypeWithPrices } from './services/apiCalls'
import './styles/global.css'
import { StepProvider } from './hooks/useStep'
import { ShoppingCartProvider } from "./hooks/useShoppingCart"
import Header from './layouts/Header'
import ProgressBar from './components/ProgressBar'
import Activation from './components/Activation'
import Debug from './pages/Debug'
import Subscriptions from './pages/Subscriptions'
import Addons from './pages/Addons'
import YourInformation from './pages/YourInformation'
import Checkout from './pages/Checkout'
import CheckoutComplete from './pages/CheckoutComplete'

function App() {
	const env = process.env.REACT_APP_ENV

	const [productsByType, setProductsByType] = useState({});
	useEffect(() => {
		getProductsByTypeWithPrices()
			.then((result) => {
				// console.log('Fetched Stripe products by type: ', result);
				setProductsByType(result);
			})
			.catch((err) => {
				console.error('Failed to fetch stripe products message:', err);
			});
	}, []);

  	return (
      	<div className='app-container'>
        	<Header />
			<ShoppingCartProvider productsByType={productsByType}>
				<StepProvider>
					<ProgressBar></ProgressBar>
					<div className='page-wrapper'>
						<Routes>
							{/* <Route path="/" element={<Navigate to="/subscriptions" replace />} /> */}
							<Route path="/subscriptions" element={<Subscriptions products={productsByType?.main}/>} />
							<Route path="/addons" element={<Addons products={productsByType?.addon}/>} />
							<Route path="/your-information" element={<YourInformation />} />
							<Route path="/checkout" element={<Checkout />} />
							<Route path="/checkout-complete" element={<CheckoutComplete />} />
							<Route path="/activation" element={<Activation />} />
							<Route path="*" element={<Navigate to="/subscriptions" replace />} />
							{ (env === 'local' || env === 'dev' || env === 'uat') &&
								<Route path="/debug" element={<Debug />} />
							}
						</Routes>
					</div>
				</StepProvider>
			</ShoppingCartProvider>
      	</div>
  	);
}

export default App;
